
@if (requireOldPassword) {
  <div class="field">
    <label for="passwordOld">{{'PASSWORD_OLD' | translate}}</label><br>
    <input id="passwordOld" type="password" pInputText
           [(ngModel)]="passwordOld"
           class="p-inputtext-sm w-full"
           [disabled]="isLoading">
  </div>
}

<div class="field">
  <label for="password2">{{'PASSWORD_NEW' | translate}}</label><br>
  <input id="password2" type="password" pInputText
         [(ngModel)]="passwordNew"
         [placeholder]="'PASSWORD_PLACEHOLDER_MIN_X' | translate: {value: passwordMinLength}"
         [minlength]="passwordMinLength"
         class="p-inputtext-sm w-full"
         [disabled]="isLoading">
</div>
<div class="field">
  <label for="password3">{{'PASSWORD_RETYPE' | translate}}</label><br>
  <input id="password3" type="password" pInputText
         [(ngModel)]="passwordRetype"
         (keydown.enter)="changePassword()"
         [minlength]="passwordMinLength"
         class="p-inputtext-sm w-full"
         [disabled]="isLoading">
</div>

@if (errorMsg) {
  <div class="mb-2">
    <p-message severity="error" [text]="errorMsg"/>
  </div>
}

<div class="flex justify-content-end">
  <p-button [label]="'CHANGE_PASSWORD' | translate"
            (onClick)="changePassword()"
            icon="pi pi-sign-in" [loading]="isLoading"/>
</div>
